<template>
  <div class="register-success">
    <div style="display: grid; gap: 8px">
      <div class="w-full flex justify-center" style="padding-top: 28px; padding-bottom: 4px">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="#7367F0" />
          <g clip-path="url(#clip0_36267_13871)">
            <path d="M20.4002 29.0393L15.3602 23.9993L13.6802 25.6793L20.4002 32.3993L34.8002 17.9993L33.1202 16.3193L20.4002 29.0393Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_36267_13871">
              <rect width="28.8" height="28.8" fill="white" transform="translate(9.6001 9.59961)" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div style="display: grid; gap: 20px; padding: 10px 0; text-align: center">
        <p style="font-size: 24px; font-weight: 500">
          {{ $t("name님 account의", { name, account }) }}
          {{ $t("회원가입 신청이 성공적으로 완료되었습니다.") }}
        </p>
        <p style="font-size: 15px">{{ $t("회원가입 승인이 완료되면 안전하고 편리하게 서비스를 이용하실 수 있습니다.") }}</p>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button color="secondary" @click="onClickClose"
        ><span style="font-weight: 500">{{ $t("로그인페이지로 이동") }}</span></vs-button
      >
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onClickClose() {
      this.$emit("close");
    },
  },
  props: {
    account: String,
    name: String,
  },
};
</script>
<style scoped lang="scss">
.register-success {
  background: #fff;
  border: 1px solid #e7e9ef;
  border-radius: 8px;
  padding: 20px 30px;

  display: grid;
  gap: 40px;
}
</style>
